module.exports = __webpack_public_path__ + "static/media/hz_tu5.91197d39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hz_tu5.jpg
// module id = 1593
// module chunks = 10